import { render, staticRenderFns } from "./AllScoreCards.vue?vue&type=template&id=84011666"
import script from "./AllScoreCards.vue?vue&type=script&lang=js"
export * from "./AllScoreCards.vue?vue&type=script&lang=js"
import style0 from "./AllScoreCards.vue?vue&type=style&index=0&id=84011666&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports